// Project
import request from "../request";

/**
 * Get all decisions for a project.
 */
export const getDecisions = async (projectId) => {
	const response = await request({
		url: `/api/decision-log/decisions?projectId=${projectId}`,
		method: "GET",
	});

	const decisions = response.data.map((decision) => {
		return {
			_id: decision._id,
			decision: decision.decision,
			createdAt: new Date(decision.created_at),
			updatedAt: new Date(decision.updated_at),
			updatedBy: decision.updated_by,
		};
	});

	return decisions;
};

export const getDecisionLogProjectById = async (projectId) => {
	const response = await request({
		url: `/api/decision-log/projects/${projectId}`,
		method: "GET",
	});

	return response.data;
};
